import "./Footer.scss"
import React from 'react';

export default function Footer(){
    return(
        <footer className='footer'>
            <p>© {process.env.REACT_APP_CURRENT_YEAR} - Hamaspik Kings</p>
            <p>{process.env.REACT_APP_ENVIRONMENT_NAME} - Version {process.env.REACT_APP_CURRENT_BUILD_NUMBER}</p>
        </footer>
    )
}